'use client';
import { sidebarLinks } from './data';
import companyLogo from '../../assets/images/company-Logo-white.svg';
import { Link } from 'react-router-dom';

const Sidebar = ({ currentPage }) => {
  return (
    <aside className='desktop-sidebar'>
      <Link to='/dashboard/overview' className='logo'>
        <img src={companyLogo} alt='wealthbridge investments' />
      </Link>
      <ul className='links'>
        {sidebarLinks.map((link, linkIndex) => {
          const { icon, name, link: pageLink } = link;
          return (
            <li
              className={
                currentPage.toLocaleLowerCase().includes(pageLink)
                  ? `active`
                  : ``
              }
              key={linkIndex}
            >
              <Link to={pageLink}>
                {icon} {name}
              </Link>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default Sidebar;
